import React, { Component } from 'react';

import { PropTypes } from 'prop-types';
import { strings } from './strings';
import { TransportAuthorityInterfaces } from './transportAuthorityInterfaces/TransportAuthorityInterfaces';
import { ProviderInterfaces } from './providerInterfaces/ProviderInterfaces';

export class Interfaces extends Component {
    static contextTypes = {
        selectApp: PropTypes.func,
        selectedProvider: PropTypes.string
    }

    componentDidMount() {
        this.context.selectApp('datamanager', false);
    }

    // ----------------------

    isTransportAuthorityData() {
        const { selectedProvider } = this.context;

        return undefined !== selectedProvider && selectedProvider.startsWith("0:");
    }

    // ----------------------

    renderMapPoints() {
        if (this.isTransportAuthorityData()) {
            return <TransportAuthorityInterfaces title={strings.managingPictograms} />
        }

        return <ProviderInterfaces title={strings.managingPictograms} />
    }

    render() {
        return (
            <div>
                {this.renderMapPoints()}
            </div>
        );
    }
}
